import * as St from "./styles";

interface Props {
  borderColor: string;
  label: string;
  value: string | number;
  onClick?: () => void;
  isActive?: boolean;
}

const CardCount = ({ borderColor, label, value, onClick, isActive }: Props) => {
  return (
    <div
      className={`
        bg-white 
        shadow-muted-down 
        width-100pct 
        height-90 
        display-flex 
        align-items-center 
        border 
        border-width-2
        border-style-solid
        border-color-transparent
        cursor-pointer
        hover-shadow-lg
        hover-bg-highlight-lightest 
        ${isActive ? 'bg-highlight-lightest border-color-primary' : ''}
      `}
      onClick={onClick}
    >
      <div
        className={`
          width-100pct 
          display-flex 
          align-items-center 
          jusfity-content-space-between 
          padding-left-10 
          padding-right-10
          ${isActive ? 'padding-left-10 padding-right-10' : ''}
        `}
        style={{ borderLeft: `8px solid ${borderColor}` }}
      >
        <div className="width-90pct">
          <span className="text-color-dark text-normal margin-right-10 text-size-16 padding-right-5">{label}</span>
        </div>
        <div>
          <span className="text-color-primary text-medium text-size-h4">
            {value}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CardCount;

